{
  "nl": {
    "history": {
      "heading": {
        "title": "Mijn Geschiedenis"
      },
      "empty": {
        "noHistory": "Je hebt nog geen bestellingen. Neem eens een kijkje in de cursussen."
      },
      "links": {
        "allCourses": "Alle cursussen in de catalogus"
      },
      "group": {
        "heading": {
          "title": "Groepen",
          "group": "Groep",
          "access": "Toegang",
          "link": "Link",
          "actions": "Acties"
        },
        "links": {
          "goToGroup": "Naar de groep",
          "myMaterial": "Mijn Materiaal",
          "editMaterial": "Projectwerk bewerken",
          "createMaterial": "Projectwerk indienen",
          "downloadCertificate": "Certificaat downloaden",
          "adminArea": "Beheeromgeving"
        }
      },
      "course": {
        "heading": {
          "title": "Mijn Cursussen",
          "course": "Cursus",
          "access": "Toegang",
          "certificate": "Certificaat"
        },
        "links": {
          "downloadCertificate": "Certificaat downloaden"
        },
        "infos": {
          "missingProcess": "Nog nodig voor het certificaat:"
        }
      }
    }
  }
}
